import { useTheme } from 'react-native-paper';
import {
  Pressable,
  PressableProps,
  StyleSheet,
  Text,
  TextStyle,
  View,
  ViewStyle,
} from 'react-native';
import { Color } from '@/GlobalStyles';
import { Link } from 'expo-router';
import { LinkProps } from 'expo-router/build/link/Link';
import { PropsWithChildren, ReactNode } from 'react';
import {useTranslation} from "react-i18next";


const Outer = (outerProps: PropsWithChildren<Partial<LinkProps>>) => {
  const { href, children } = outerProps;
  if (href) {
    return (
      <Link href={href} asChild>
        {children}
      </Link>
    );
  }
  return children;
};

const SimpleLink = (
  props: PropsWithChildren<Partial<PressableProps & LinkProps>> & {
    image?: ReactNode;
    active?: boolean;
    style?: ViewStyle;
    textStyle?: TextStyle;
    inactiveBorderColor?: string;
  }
) => {
  const {
    children,
    href,
    ref,
    style,
    textStyle,
    image,
    active = true,
    inactiveBorderColor = 'transparent',
    ...rest
  } = props;

  const theme = useTheme();

  const { t } = useTranslation();

  return (
    <Outer href={href}>
      <Pressable {...rest}>
        <View
          style={[
            {
              overflow: 'visible',
              paddingBottom: 0,
              marginBottom: 0,
              borderBottomWidth: 1,
              marginHorizontal: 0,
              borderRadius: 0,
              borderColor: active ? theme.colors.secondary : inactiveBorderColor,
              flexDirection: 'row',
              justifyContent: 'flex-start',
              alignSelf: 'flex-start',
            },
            style,
          ]}
        >
          {image}
          <Text
            style={[
              styles.btnlienSimpleBtn,
              {
                textAlignVertical: 'bottom',
              },
              active ? null : { color: Color.colorGray_150 },
              textStyle,
            ]}
          >
            {t(children)}
          </Text>
        </View>
      </Pressable>
    </Outer>
  );
};

export default SimpleLink;

const styles = StyleSheet.create({
  btnlienSimpleBtn: {
    color: Color.MainBleu,
    fontSize: 14,
    fontFamily: 'Roboto_Regular',
  },
});
